import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Terminal, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="relative flex min-h-screen items-center justify-center bg-[#050505] px-4 text-white"
      data-testid="login-page"
    >
      <div className="pointer-events-none absolute inset-0 bg-grid opacity-50" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,255,255,0.12),_transparent_55%)]" />

      <Link
        to="/"
        className="absolute left-4 top-4 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-zinc-500 hover:text-cyan-300"
        data-testid="back-home-link"
      >
        <ArrowLeft className="h-3 w-3" /> voltar
      </Link>

      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-black/70 p-8 backdrop-blur-xl shadow-[0_0_40px_rgba(0,255,255,0.08)]"
        data-testid="login-form"
      >
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-cyan-400/40 bg-cyan-400/10 text-cyan-300">
            <Terminal className="h-5 w-5" />
          </div>
          <div>
            <h1 className="font-display text-xl font-black tracking-tight">
              Admin Console
            </h1>
            <p className="font-mono text-xs text-zinc-500">
              acesso restrito
            </p>
          </div>
        </div>

        <label className="mb-1 block font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">
          Email
        </label>
        <input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full rounded-md border border-white/15 bg-black p-3 font-mono text-sm text-white outline-none transition focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400"
          placeholder="admin@..."
          data-testid="login-email-input"
        />

        <label className="mb-1 block font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">
          Senha
        </label>
        <input
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4 w-full rounded-md border border-white/15 bg-black p-3 font-mono text-sm text-white outline-none transition focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400"
          placeholder="••••••••"
          data-testid="login-password-input"
        />

        {error && (
          <div
            className="mb-4 rounded-md border border-red-500/40 bg-red-500/10 p-3 font-mono text-xs text-red-300"
            data-testid="login-error"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-md bg-cyan-400 p-3 font-display text-sm font-bold uppercase tracking-[0.2em] text-black transition hover:bg-emerald-400 hover:shadow-[0_0_24px_rgba(57,255,20,0.55)] disabled:opacity-60"
          data-testid="login-submit-button"
        >
          {loading ? "..." : "entrar"}
        </button>
      </form>
    </div>
  );
}
